import React, { useState, useCallback, useEffect, useMemo } from "react";
import useStyles from "./style";
import { useSelector } from "react-redux";
import { Button, Grid, Typography, Menu, MenuItem, TextField, InputAdornment, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import DashboardIcon from "@mui/icons-material/Dashboard";
import "jspdf-autotable";
import io from "socket.io-client";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { closeSidebar } from "Redux/Sidebar/actions";
import { useNavigate } from 'react-router-dom';
import { useFormik, useField } from "formik";
import * as yup from "yup";
import _ from "lodash";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from 'moment-timezone';
import { API_ENDPOINTS, CUSTOM_CONSTANTS } from "Constants";
import DataTable from "react-data-table-component";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";
//models
import Passengerhistorydetails from "Pages/Modals/Passengerhistory/Tripdetails";
import Cancelcurrentride from "Pages/Modals/Passengerhistory/Canceltheride"
//Services
import TriplistApi from "Services/Triplist";

const TripList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);
  const timezone = useSelector((state) => state.timezone.timezone);
  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(30); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [searchText, setSearchText] = useState("");
  const openaction = Boolean(anchorEl);
  const Tripstatus = ["SEARCHING", "CANCELLED", "COMPLETED", "SCHEDULED"];
  const Bookingtype = ["MOBILE APP", "WEB BOOKING", "STREET RIDE"];
  const Bookingtypevalue = ["MOBILE_APP", "WEB_BOOKING", "STREET_RIDE"];
  const [servicesData, setServicesData] = useState([]);
  const [filtervalues, setFiltervalues] = useState({});
  const demoaccount_id = useSelector((state) => state?.AuthReducer?.demoaccount_id || "");
  //Modals
  const [requestId, setrequestId] = useState("");
  const [moredetailsmodel, setmoredetailsModal] = useState(false);
  const [cancelridemodel, setcancelrideModal] = useState(false);
  // console.log('localStorage.getItem-->',`Bearer ${localStorage.getItem("token")}`);
  // console.log('localStorage.getItem-->',localStorage.getItem("userType"));
  const socket = useMemo(() => {
    return io(CUSTOM_CONSTANTS.API_BASE_URL, {
      query: {
        authtoken: `Bearer ${localStorage.getItem("token")}`, // Replace with actual token
      },
      transports: ["websocket"],
      path: "/socket.io/",
    });
  }, []); // Replace with your server URL

  useEffect(() => {
    return () => {
      socket.disconnect();
    };
  }, [socket]);

  // Close sidebar when this page loads
  useEffect(() => {
    dispatch(closeSidebar());
  }, [dispatch]);

  useEffect(() => {
    dispatch(showLoader("Loading please wait..."));
    // Request all user ride requests
    const interval = setInterval(() => {
      // console.log('triggered-->')
      socket.emit("hotelgetAllUserRideRequests", { page, limit: pageSize, filtervalues: { ...filtervalues, demoaccount_id } });
    }, 5000);
    // Initial load
    socket.emit("hotelgetAllUserRideRequests", { page, limit: pageSize, filtervalues: { ...filtervalues, demoaccount_id } });
    // Listen for trip list updates
    socket.on("hoteltripListUpdated", (data) => {
      if (data.success) {
        dispatch(hideLoader());
        // console.log('data--->',data);
        setTotalPages(data?.data?.totalRecords || 1);
        console.log('res?.data?.data?.data--->', data);
        setRow(data?.data?.data.triplists);
        setServicesData(data?.data?.data.serviceTypeDetails)
      }
      else {
        setRow([]);
      }
    });

    socket.on("loginStatus", (data) => {
      if (data.message) {
        //    console.log("Socket data-->", data); // Update table rows
      }
    });

    socket.on("disconnect", () => {
      // console.log("Socket disconnected");
    });

    // Cleanup socket connection
    return () => {
      clearInterval(interval);
      socket.off("hoteltripListUpdated");
      socket.off("disconnect");

    };
  }, [page, pageSize, filtervalues, demoaccount_id, socket, dispatch]);

  const handleopenCancelModel = (_id) => {
    setrequestId(_id);
    setcancelrideModal(true);
    setAnchorEl(null);
  };

  const handlecloseCancelModel = () => {
    setcancelrideModal(false);
    socket.emit("hotelgetAllUserRideRequests", { page, limit: pageSize, filtervalues: { ...filtervalues, demoaccount_id } });
  };

  function formatDate(inputDate) {
    if (!inputDate) return "--";

    // Handle MongoDB date object: { $date: "..." }
    const dateValue = inputDate?.$date || inputDate;

    if (!dateValue) return "--";

    // Fallback timezone if undefined
    const tz = timezone || "UTC";

    // Validate date before formatting
    if (!moment(dateValue).isValid()) return "--";

    return moment(dateValue).tz(tz).format("YYYY-MM-DD hh:mm A");
  };


  const handleOpenmoredetailsModal = (_id) => {
    setrequestId(_id);
    setmoredetailsModal(true);
    setAnchorEl(null);
  };

  const handleClosemoredetailsModal = () => {
    setmoredetailsModal(false);
  };

  const filteredData = row.filter((data) => {
    return (
      data.bookingId?.toLowerCase().includes(searchText.toLowerCase()) ||
      formatDate(data.requestedAt)?.toLowerCase().includes(searchText.toLowerCase()) ||
      formatDate(data.startedAt)?.toLowerCase().includes(searchText.toLowerCase()) ||
      formatDate(data.completedAt)?.toLowerCase().includes(searchText.toLowerCase()) ||
      `${data.userdetails?.firstName} ${data.userdetails?.lastName}`.toLowerCase().includes(searchText.toLowerCase()) ||
      (data.driverdetails ? `${data.driverdetails.firstName} ${data.driverdetails.lastName}` : "Not Exists")
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      data.servicedetails?.serviceName.toLowerCase().includes(searchText.toLowerCase()) ||
      data.pickupAddress.toLowerCase().includes(searchText.toLowerCase()) ||
      data.dropAddress.toLowerCase().includes(searchText.toLowerCase()) ||
      `${data.tripDistance}`.toLowerCase().includes(searchText.toLowerCase()) ||
      `${data.estimatedFare}`.toLowerCase().includes(searchText.toLowerCase()) ||
      `${data.bookingType}`.toLowerCase().includes(searchText.toLowerCase()) ||
      data.cancelledBy.toLowerCase().includes(searchText.toLowerCase()) ||
      data.tripStatus.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  const columns = [
    {
      name: "S.No",
      selector: (_, index) => index + 1 + (page - 1) * pageSize,
      sortable: false,
      width: "4%",
    },
    {
      name: "Booking ID",
      selector: (row) => row.bookingId,
      sortable: false,
      wrap: true,
      width: "7%",
      cell: (row) => (
        <Box
          onClick={() => handleOpenmoredetailsModal(row._id)}
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            cursor: "pointer",
            color: "#9c27b0", // Optional: Color to indicate it's clickable
          }}
        >
          <Typography variant="body2" style={{ fontSize: "12px", fontWeight: "bold" }} >{row.bookingId}</Typography>
          <LocationOnIcon style={{ fontSize: "16px" }} />
        </Box>
      ),
    },
    {
      name: "Booking Time",
      selector: (row) => formatDate(row.requestedAt),
      sortable: false,
      wrap: true,
      width: "6%",
    },
    {
      name: "Pickup Time",
      selector: (row) => formatDate(row.startedAt ? row.startedAt : row.scheduleAt),
      sortable: false,
      wrap: true,
      width: "6%",
    },
    {
      name: "Drop Time",
      selector: (row) => formatDate(row.completedAt),
      sortable: false,
      wrap: true,
      width: "6%",
    },
    {
      name: "Passenger Name",
      selector: (row) => `${row.userdetails?.firstName || ""} ${row.userdetails?.lastName || ""}`,
      sortable: false,
      wrap: true,
      width: "7%",
    },
    {
      name: "Driver Name",
      selector: (row) =>
        row.driverdetails ? `${row.driverdetails.firstName} ${row.driverdetails.lastName}` : "Not Exists",
      sortable: false,
      wrap: true,
      width: "7%",
    },
    {
      name: "Service",
      selector: (row) => row.servicedetails?.serviceName,
      sortable: false,
      wrap: true,
      width: "6%",
    },
    {
      name: "Pickup Location",
      selector: (row) => row.pickupAddress,
      sortable: false,
      wrap: true,
      width: "9%",
    },
    {
      name: "Drop Location",
      selector: (row) => row.dropAddress,
      sortable: false,
      wrap: true,
      width: "9%",
    },
    {
      name: "Distance",
      selector: (row) => `${(row.tripDistance ?? 0).toFixed(2)} Km`,
      sortable: false,
      wrap: true,
      width: "6%",
    },
    {
      name: "Fare",
      selector: (row) => `${row.estimatedFare ?? 0} ${CUSTOM_CONSTANTS.BASE_CURRENCY}`,
      sortable: false,
      wrap: true,
      width: "5%",
    },
    {
      name: "Booking Type",
      selector: (row) => row.bookingType,
      sortable: false,
      wrap: true,
      width: "8%",
      cell: (row) => (
        <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
          <span>{row.bookingType == "WEB_BOOKING" ? "DISPATCHER" : row.bookingType}</span>
          {row.bookingType == "MOBILE_APP" &&
            row.userdetails?.device_type === "android" && (
              // <AndroidIcon fontSize="small" sx={{ color: "green" }} />
              <img src="/assets/images/DispatcherIcons/Andriod.png" alt="Android" />
            )}
          {row.bookingType == "MOBILE_APP" &&
            row.userdetails?.device_type === "ios" && (
              <img src="/assets/images/DispatcherIcons/Apple.png" alt="Ios" />
              // <AppleIcon fontSize="small" />

            )}

        </Box>
      ),
    },
    {
      name: "Cancelled By",
      selector: (row) => row.cancelledBy == "NODRIVER" ? "NO DRIVER" : row.cancelledBy || "--",
      sortable: false,
      wrap: true,
      width: "6%",
    },
    {
      name: "Status",
      selector: (row) => row.tripStatus,
      sortable: false,
      wrap: true,
      width: "8%",
      cell: (row) => {
        const statusColors = {
          SEARCHING: "#f39c12",  // Orange
          CANCELLED: "#e12f2f",  // Red
          COMPLETED: "#5cb85c",  // Green
          STARTED: "#007bff",    // Blue
          DROPPED: "#6c757d",    // Grey
          ARRIVED: "#ff9800",    // Amber
          PICKEDUP: "#17a2b8",   // Teal
          READY: "#8e44ad",      // Purple
        };

        const isFinalStatus = row.tripStatus === "COMPLETED" || row.tripStatus === "CANCELLED";

        if (isFinalStatus) {
          return (
            <Typography
              variant="body2"
              style={{
                backgroundColor: statusColors[row.tripStatus] || "#ccc",
                color: "#fff",
                padding: "6px 5px",
                borderRadius: "18px",
                textAlign: "center",
                fontSize: "10px",
                display: "inline-block",
                whiteSpace: "nowrap",
              }}
            >
              {row.tripStatus}
            </Typography>
          );
        } else {
          return (
            <button
              onClick={() => handleopenCancelModel(row._id)}
              style={{
                backgroundColor: statusColors[row.tripStatus] || "#007bff",
                color: "#fff",
                padding: "6px 5px",
                border: "none",
                borderRadius: "18px",
                cursor: "pointer",
                fontSize: "10px",
                whiteSpace: "nowrap",
              }}
            >
              {row.tripStatus}
            </button>
          );
        }

      },
    },
  ];

  // handle dates

  const handlefromdate = (newValue) => {
    if (newValue === null || newValue === "") {
      formik.setFieldValue("fromdate", newValue);
    } else {
      const selectedDate =
        newValue instanceof Date ? newValue : new Date(newValue);
      const parsedDate = moment(selectedDate);
      const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
      formik.setFieldValue("fromdate", formattedDate);
    }
  };

  const handletodate = (newValue) => {
    if (newValue === null || newValue === "") {
      formik.setFieldValue("todate", newValue);
    } else {
      const selectedDate =
        newValue instanceof Date ? newValue : new Date(newValue);
      const parsedDate = moment(selectedDate);
      const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
      formik.setFieldValue("todate", formattedDate);
    }
  };

  // filter form 

  function convertToISO(inputDate) {
    if (!inputDate) {
      return "--"; // Handle null or undefined input
    }

    // Parse the input date string
    const date = new Date(inputDate);

    if (isNaN(date.getTime())) {
      return "--"; // Handle invalid date formats
    }

    // Convert to ISO string and replace "Z" with "+00:00" for UTC offset
    const isoString = date.toISOString().replace("Z", "+00:00");
    return isoString;
  }

  const handlefiltertriplist = (formValues) => {
    formValues.fromdate = convertToISO(formValues.fromdate);
    formValues.todate = convertToISO(formValues.todate);
    formValues.demoaccount_id = demoaccount_id; // Add demoaccount_id filter
    // console.log('formValues-->',formValues);
    dispatch(showLoader("Loading please wait..."));
    setFiltervalues(formValues);
  };

  const formik = useFormik({
    initialValues: {
      tripStatus: "",
      serviceTypeId: "",
      bookingType: "",
      fromdate: "",
      todate: "",
    },
    validationSchema: yup.object({
      fromdate: yup.string().required("From date is required").nullable(),
      todate: yup.string().required("To date is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      handlefiltertriplist(values); // Ensure this processes `values` correctly
    },
  });

  const roundedInputStyle = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "25px",
    },
  };


  return (
    <>

      <div className={classes.pages}>
        <Grid container className={classes.root}>

          <Grid container className={classes.utilities}>

            <Grid item xs={6} md={4} lg={2} xl={2} className={classes.filters}>
              <TextField
                name="tripStatus"
                id="tripStatus"
                select
                className={classes.txtwidth}
                sx={roundedInputStyle}
                value={formik?.values?.tripStatus || ""}
                onChange={formik?.handleChange}
                error={
                  formik?.errors?.tripStatus &&
                  formik?.touched?.tripStatus
                }
                helperText={
                  formik?.errors?.tripStatus &&
                  formik?.touched?.tripStatus &&
                  formik?.errors?.tripStatus
                }
                fullWidth
                variant="outlined"
                size="small"
                SelectProps={{
                  displayEmpty: true,
                  IconComponent: () => null,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <img
                        src="/assets/images/sidebar_icons/All Status.png"
                        alt="status"
                        width="28"
                        style={{ pointerEvents: "none" }}
                      />
                    </InputAdornment>
                  ),
                }}
              >
                <MenuItem value="" >All Status</MenuItem>
                {Tripstatus.map((status) => (
                  <MenuItem key={status} value={status}>
                    {status}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} md={4} lg={2} xl={2} className={classes.filters}>
              <TextField
                name="serviceTypeId"
                select
                fullWidth
                size="small"
                sx={roundedInputStyle}
                className={classes.txtwidth}
                value={formik?.values?.serviceTypeId || ""}
                onChange={formik?.handleChange}
                SelectProps={{
                  displayEmpty: true,
                  IconComponent: () => null,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <img
                        src="/assets/images/sidebar_icons/All Services.png"
                        width="28"
                        alt=""
                        style={{ pointerEvents: "none" }}
                      />
                    </InputAdornment>
                  ),
                }}
              >
                <MenuItem value="" >All Services</MenuItem>
                {servicesData.map((services) => (
                  <MenuItem key={services._id} value={services._id}>
                    {services.serviceName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} md={4} lg={2} xl={2} className={classes.filters}>
              <TextField
                name="bookingType"
                select
                fullWidth
                size="small"
                sx={roundedInputStyle}
                className={classes.txtwidth}
                value={formik?.values?.bookingType || ""}
                onChange={formik?.handleChange}
                SelectProps={{
                  displayEmpty: true,
                  IconComponent: () => null,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <img
                        src="/assets/images/sidebar_icons/All Booking.png"
                        width="28"
                        alt=""
                        style={{ pointerEvents: "none" }}
                      />
                    </InputAdornment>
                  ),
                }}
              >
                <MenuItem value="">All Booking type</MenuItem>
                {Bookingtype.map((label, index) => (
                  <MenuItem key={Bookingtypevalue[index]} value={Bookingtypevalue[index]}>
                    {label}
                  </MenuItem>
                ))}

                {/* <MenuItem value="" >All Booking type</MenuItem>
{Bookingtype.map((booking) => (
  <MenuItem key={booking} value={booking}>
    {booking}
  </MenuItem> */}
              </TextField>
            </Grid>
            <Grid item xs={6} md={4} lg={2} xl={2} className={classes.filters}>
              <div className={classes.datePickerStyle}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    sx={roundedInputStyle}

                    label="From Date"
                    value={formik?.values?.fromdate || ""}
                    size="small"
                    onChange={(newValue) => {
                      handlefromdate(newValue);
                    }}
                    components={{
                      OpenPickerIcon: () => (
                        <img
                          src="/assets/images/Dateicon.png"
                          alt="date"
                          width="20"
                          style={{ pointerEvents: "none" }}
                        />
                      ),
                    }}
                    renderInput={(params) => (
                      <TextField
                        sx={roundedInputStyle}
                        className={classes.txtwidth}
                        {...params}
                        error={
                          formik?.errors?.fromdate &&
                          formik?.touched?.fromdate
                        }
                        helperText={
                          formik?.errors?.fromdate &&
                          formik?.touched?.fromdate &&
                          formik?.errors?.fromdate
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </Grid>
            <Grid item xs={6} md={4} lg={2} xl={2} className={classes.filters}>
              <div className={classes.datePickerStyle}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="To Date"
                    value={formik?.values?.todate || ""}
                    size="small"
                    sx={roundedInputStyle}

                    onChange={(newValue) => {
                      handletodate(newValue);
                    }}
                    components={{
                      OpenPickerIcon: () => (
                        <img
                          src="/assets/images/Dateicon.png"
                          alt="date"
                          width="20"
                          style={{ pointerEvents: "none" }}
                        />
                      ),
                    }}
                    renderInput={(params) => (
                      <TextField
                        sx={roundedInputStyle}
                        className={classes.txtwidth}
                        {...params}
                        error={
                          formik?.errors?.todate &&
                          formik?.touched?.todate
                        }
                        helperText={
                          formik?.errors?.todate &&
                          formik?.touched?.todate &&
                          formik?.errors?.todate
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </Grid>
            <Grid item xs={6} md={2} lg={1} xl={1} className={classes.Endbtn}>
              <Button variant="contained" className={classes.buttonStyle} onClick={formik?.handleSubmit} startIcon={<FilterListIcon />} style={{ fontSize: '13px', padding: '8px 16px' }}>
                Filter
              </Button>
            </Grid>
            <Grid item xs={6} md={2} lg={1} xl={1} className={classes.Endbtn}>
              <Button variant="contained" className={classes.buttonStyle} onClick={() => { navigate('/dashboard') }} startIcon={<DashboardIcon />} >
                Dashboard
              </Button>
            </Grid>

          </Grid>

          <Grid item xs={12} >
            <section className={classes.dataGridTable}>
              <div className={classes.searchBarWrapper}>
                {/* Search Bar */}
                <TextField
                  sx={roundedInputStyle}
                  className={classes.TextFieldwidth}
                  label=""
                  variant="outlined"
                  size="small"
                  placeholder="Search"
                  fullWidth
                  margin="normal"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className={classes.tableContainer}>
                <DataTable
                  columns={columns}
                  data={filteredData}
                  noDataComponent={null}
                  pagination
                  paginationServer
                  paginationTotalRows={totalPages}
                  paginationPerPage={pageSize}
                  paginationComponentOptions={{ rowsPerPageText: "Rows per page:" }}
                  onChangePage={(newPage) => setPage(newPage)}
                  onChangeRowsPerPage={(newPageSize) => setPageSize(newPageSize)}
                  highlightOnHover
                  fixedHeader
                  responsive
                  keyField="_id"
                  customStyles={{
                    headRow: {
                      style: {
                        fontWeight: "bold",
                        fontSize: "clamp(11px, 0.9vw, 14px)",
                        backgroundColor: "#f5f5f5",
                        justifyContent: "center",
                        padding: "8px 4px",
                        minHeight: "40px",
                      },
                    },
                    headCells: {
                      style: {
                        fontWeight: "700",
                        fontSize: "clamp(10px, 0.85vw, 13px)",
                        paddingRight: "4px",
                        paddingLeft: "4px",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        lineHeight: "1.3",
                        justifyContent: "center",
                        textAlign: "center",
                        textTransform: "uppercase",
                        letterSpacing: "0.3px",
                        color: "#333",
                      },
                    },
                    cells: {
                      style: {
                        whiteSpace: "normal",
                        fontSize: "clamp(10px, 0.8vw, 12px)",
                        fontWeight: "600 !important",
                        wordBreak: "break-word",
                        paddingBottom: "8px",
                        paddingTop: "8px",
                        paddingRight: "4px",
                        paddingLeft: "4px",
                        lineHeight: "1.4",
                        justifyContent: "center",
                        textAlign: "center",
                      },
                    },
                    rows: {
                      style: {
                        minHeight: "44px",
                        "&:hover": {
                          backgroundColor: "#f8f9fa !important",
                          transition: "background-color 0.2s ease",
                        },
                      },
                      stripedStyle: {
                        backgroundColor: "#fafbfc",
                      },
                    },
                    pagination: {
                      style: {
                        fontSize: "clamp(11px, 0.8vw, 13px)",
                        minHeight: "44px",
                        borderTop: "1px solid #e8e8e8",
                      },
                    },
                  }}
                  striped
                />
              </div>
            </section>
          </Grid>

        </Grid>
      </div>

      <Passengerhistorydetails
        openDialog={moredetailsmodel}
        id={requestId}
        handleClose={handleClosemoredetailsModal}
      ></Passengerhistorydetails>
      <Cancelcurrentride
        openDialog={cancelridemodel}
        id={requestId}
        handleClose={handlecloseCancelModel}
      ></Cancelcurrentride>
    </>
  );
};

export default TripList;

